<div class="twc-container twc-m-2">
    <div class="twc-mt-1 twc-mb-3" *ngIf="subtitle">{{subtitle | translate}}</div>

    <div class="twc-row twc-col-12 twc-mb-2">
        <h3 class="twc-h3">{{'UPLOAD.POINTCLOUD_CONFIGURATION' | translate}}</h3>
    </div>

    <div>
        <span class="twc-form-label">
            <strong>{{'UPLOAD.POINTCLOUD_QUALITY_SELECT' | translate}}</strong>
        </span>

        <div class="twc-row-center">
            <twc-select class="twc-col-5 twc-col-sm-3" [(ngModel)]="pointcloudData.config" (ngModelChange)="change()">
                <twc-select-option *ngFor="let option of options" [value]="option.value">
                    {{ option.label | translate}}
                </twc-select-option>
            </twc-select>
            <span class="twc-ml-1">{{qualityMessage | translate}}</span>
        </div>
    </div>
</div>